import { motion } from "framer-motion";

interface MissionVisionSectionProps {
  data?: {
    mission?: string;
    vision?: string;
  };
}

export const MissionVisionSection = ({ data }: MissionVisionSectionProps) => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  return (
    <motion.section {...fadeIn} className="space-y-6 text-left">
      <div className="space-y-4">
        <h2 className="text-3xl font-semibold">Our Mission</h2>
        <p className="text-lg text-muted-foreground leading-relaxed">
          {data?.mission || "To revolutionize hospitality operations through cutting-edge technology, smart automation, and customer-first solutions."}
        </p>
      </div>
      <div className="space-y-4">
        <h2 className="text-3xl font-semibold">Our Vision</h2>
        <p className="text-lg text-muted-foreground leading-relaxed">
          {data?.vision || "To be the global leader in hospitality tech, driving operational excellence and redefining industry standards."}
        </p>
      </div>
    </motion.section>
  );
};